import { Badge as BadgeComponent } from '@elfsight/widget-ui';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export const Badge = () => {
  const {
    badgeColor,
    badgeRadius,
    badgeText,
    badgeStyle,
    barSize,
    barSizeMobile
  } = useSettings();

  const isMobile = useIsMobile();

  if (!badgeText) return;

  return (
    <BadgeComponent
      borderMode={badgeRadius}
      size={isMobile ? barSizeMobile : barSize}
      color={badgeColor}
      mode={badgeStyle}
    >
      {badgeText}
    </BadgeComponent>
  );
};
